import objectFitImages from 'object-fit-images';
import './Polyfill/ArrayIncludes';
import './Polyfill/ObjectAssign';
import './Polyfill/AfterMethod';
import './Polyfill/ObjectKeysPolyfill';
import '../../../../Cts.CtsReisenDe.Shared/Resources/Private/Javascript/Index.js';
import '../../../../Cts.CtsReisenDe.PersonalOffers/Resources/Private/Javascript/Index.js';
import '../../../../Cts.CtsReisenDe.Catalog/Resources/Public/JavaScript/main.js';
require('es6-promise').polyfill();
import 'whatwg-fetch';
import SimpleTeaserStyleFix from './Stylefix/SimpleTeaser';

import Accordeon from '@components-sites-cts/Molecule/Accordeon';
import BottomBar from '@components-sites-cts/Atom/Bar/Bottom';
import FormConditionalBlock from '@components-sites-cts/Base/Form/ConditionalBlock';
import FormField from '@components-sites-cts/Base/Form';
import PreventMultisubmit from '@components-sites-cts/Base/Form/PreventMultisubmit';
import Gallery from '@components-sites-cts/Molecule/Gallery';
import { Navigation, ToggleNavigation } from '@components-sites-cts/Molecule/Navigation';
import Ratings from '@components-sites-cts/Atom/Rating';
import Search from '@components-sites-cts/Molecule/Search';
import StickyNavigation from '@components-sites-cts/Molecule/Navigation/Sticky';
import TeaserSimple from '@components-sites-cts/Molecule/Teaser/Simple';
import Video from '@components-sites-cts/Atom/Video';
import Map from '@components-sites-cts/Molecule/Map';
import Accomodation from '@components-sites-cts/Molecule/Trip/Accomodation';
import Slider from '@components-sites-cts/Molecule/Teaser/Hero/Slider';
import VideoSlider from '@components-sites-cts/Molecule/Teaser/Hero/Slider/VideoSliderItem';

//
// Universal selector query function
//
const find = selector => [].slice.call(document.querySelectorAll(selector));

// Initialized state
let isInitialized = false;

//
// Initialization function
//
const initialize = () => {
  if (isInitialized === true) {
    return;
  }

  //
  // Touch detection as per
  // http://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
  //
  if ('ontouchstart' in window || navigator.maxTouchPoints) {
    document.body.classList.add('u-isTouchDevice');
  } else {
    document.body.classList.add('u-isNoTouchDevice');
  }

  find('[data-component="Accordeon"]').forEach(Accordeon);
  find('[data-component="BottomBar"]').forEach(BottomBar);
  find('[data-component="FormConditionalBlock"]').forEach(FormConditionalBlock);
  find('[data-component="FormField"]').forEach(FormField);
  find('[data-component="PreventMultisubmit"]').forEach(PreventMultisubmit);
  find('[data-component="Gallery"]').forEach(Gallery);
  find('[data-component="Map"]').forEach(Map);
  find('[data-component="Navigation"]').forEach(Navigation);
  find('[data-component="Ratings"]').forEach(Ratings);
  find('[data-component="Search"]').forEach(Search);
  find('[data-component="StickyNavigation"]').forEach(StickyNavigation);
  find('[data-component="ToggleNavigation"]').forEach(ToggleNavigation);
  find('[data-component="TeaserSimple"]').forEach(TeaserSimple);
  find('[data-component="Accomodation"]').forEach(Accomodation);
  find('[data-component="Video"]').forEach(Video);
  find('.teaserSimple').forEach(SimpleTeaserStyleFix);
  find('[data-component="Slider"]').forEach(Slider);
  find('[data-component="VideoSlider"]').forEach(VideoSlider);

  objectFitImages();

  isInitialized = true;
};

document.addEventListener('DOMContentLoaded', initialize);

// force initialisation in the neos-backend
document.addEventListener('Neos.PageLoaded', function() {
  isInitialized = false;
  initialize();
});

// start initialisation if async loading finished after dom-ready
if (isInitialized === false && (document.readyState === "complete" ||  document.readyState === "interactive")) {
  initialize();
}
